import { Authenticator } from '@aws-amplify/ui-react';
import { Amplify, I18n } from 'aws-amplify';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import AppApolloProvider from './components/app-apollo-provider';
import { authVocabularies } from './i18n/auth-vocabulary';
import authSetting from './libs/auth-setting';
import reportWebVitals from './reportWebVitals';
import './styles/index.css';

// Login Setting
Amplify.configure(authSetting);
I18n.putVocabularies(authVocabularies);
I18n.setLanguage('ja-JP');

// Deploy環境がUpdateされているかを確認するためのログ
if (process.env.NODE_ENV === 'production')
  console.log('Commit Hash', process.env.REACT_APP_CODEBUILD_RESOLVED_SOURCE_VERSION);

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <Authenticator.Provider>
      <AppApolloProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AppApolloProvider>
    </Authenticator.Provider>
  </React.StrictMode>
);

if (process.env.NODE_ENV === 'production') reportWebVitals(console.log);
